<template>
  <gf-button
    class="gf-tooltip-temporary"
    :class="{ '--show-tooltip': showCopyTooltip }"
    data-tooltip-text="Скопировано!"
    :variant="variant"
    :after-icon="!isOnlyIcon ? shareIconModel : null"
    :icon="isOnlyIcon ? shareIconModel : null"
    :text="!isOnlyIcon ? shareTextModel : null"
    :show-only-icon-mobile="true"
    @click="onShareButtonClick"
  />
</template>

<script>
import GfButton from '@/shared-modules/shared-components/shared/components/GfButton';
import HelperS from '@/shared-modules/services/helper.service';

export default {
  name: 'GfButtonShare',
  components: { GfButton },
  props: {
    title: {
      type: String,
      default: 'Gitflic'
    },
    url: {
      type: String,
      default: null,
      required: true
    },
    showOnlyIcon: {
      default: null
    },
    showTooltip: {
      type: [Boolean, String],
      default: true
    },
    variant: {
      type: String,
      default: 'secondary'
    }
  },
  data() {
    return {
      shareTextModel: 'Поделиться',
      showCopyTooltip: false,
      shareIconModel: 'gf-icon gf-icon-share-social'
    };
  },
  computed: {
    isOnlyIcon() {
      return this.showOnlyIcon === true || this.showOnlyIcon === 'true';
    }
  },
  methods: {
    onShareButtonClick() {
      const shareData = {
        title: this.title,
        url: this.url
      };
      if (!HelperS.share(shareData)) {
        this.shareTextModel = 'Скопировано';
        this.shareIconModel = 'gf-icon gf-icon-check';
        this.showCopyTooltip = Boolean(this.showTooltip) ? true : false;
        setTimeout(() => {
          this.resetTextAndIcon();
        }, 1500);
      }
    },
    resetTextAndIcon() {
      this.shareTextModel = 'Поделиться';
      this.shareIconModel = 'gf-icon gf-icon-share-social';
      this.showCopyTooltip = false;
    }
  }
};
</script>
